// src/routes/LandlordRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./AuthProvider";
import ProtectedRoute from "./ProtectedRoute";

import LandlordSignIn from "../LandLordPages/LandlordSignIn";
import LandlordDashboard from "../LandLordPages/LandlordDashboard";
import Accounting from "../LandLordPages/Accounting";
import LandlordLayout from "../layouts/LandlordLayout";
import Reservations from "../LandLordPages/Reservations";
import ForgetPassword from "../LandLordPages/ForgetPassword";
import Settings from "../LandLordPages/Settings";
import ContactWidget from "../components/ContactWidget";

export default function LandlordRoutes() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandlordSignIn />} />
        <Route path="/forget-password" element={<ForgetPassword />} />

        {/* Protected */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <LandlordLayout>
                <LandlordDashboard />
                <ContactWidget />
              </LandlordLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounting"
          element={
            <ProtectedRoute>
              <LandlordLayout>
                <Accounting />
                <ContactWidget />
              </LandlordLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reservations"
          element={
            <ProtectedRoute>
              <LandlordLayout>
                <Reservations />
                <ContactWidget />
              </LandlordLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <LandlordLayout>
                <Settings />
                <ContactWidget />
              </LandlordLayout>
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
